import type { UseData } from "@acme/types";
import {
  siBiome,
  siBitwarden,
  siBun,
  siCanva,
  siCmake,
  siDiscord,
  siDocker,
  siFigma,
  siGit,
  siGmail,
  siGooglechrome,
  siJira,
  siLlvm,
  siNodedotjs,
  siObsidian,
  siPostman,
  siRailway,
  siSpotify,
  siVercel,
  siZsh,
} from "simple-icons";

export const software: UseData[] = [
  {
    name: "Cursor",
    description: "Primary Code editor",
    icon: {
      title: "Cursor",
      slug: "cursor",
      svg: `<svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <title>Cursor</title>
    <path d="M12.001 0c-.4392.2539-6.2903 3.6214-9.596 5.5238h1.9121l7.2067-4.1484v4.1484h.9542V1.3772l7.2049 4.1466h1.912C20.2516 4.7505 12.4402.2538 12.001 0ZM1.5756 6.001 12.001 12v12L22.4243 6.001Zm0 .5516v11.4502l9.9481 5.7251v-1.0995l-8.513-4.9014 8.513-4.9014v-.5498l-.477-.274-8.5169 4.8996v-9.801Zm20.8486.4007L21.47 8.6007v8.3007l-3.6043-2.0743-.479.8256 3.6043 2.0743-7.2085 4.1503-.956 1.6493c1.3386-.7705 9.1584-5.2715 9.5977-5.5238z" />
  </svg>`,
      path: "M12.001 0c-.4392.2539-6.2903 3.6214-9.596 5.5238h1.9121l7.2067-4.1484v4.1484h.9542V1.3772l7.2049 4.1466h1.912C20.2516 4.7505 12.4402.2538 12.001 0ZM1.5756 6.001 12.001 12v12L22.4243 6.001Zm0 .5516v11.4502l9.9481 5.7251v-1.0995l-8.513-4.9014 8.513-4.9014v-.5498l-.477-.274-8.5169 4.8996v-9.801Zm20.8486.4007L21.47 8.6007v8.3007l-3.6043-2.0743-.479.8256 3.6043 2.0743-7.2085 4.1503-.956 1.6493c1.3386-.7705 9.1584-5.2715 9.5977-5.5238z",
      source: "",
      hex: "",
      guidelines: "",
    },
    link: "https://cursor.com/downloads",
  },
  {
    name: "Chrome",
    description: "Primary Browser",
    icon: siGooglechrome,
    link: "https://www.google.com/chrome",
  },
  {
    name: "Gmail",
    description: "Primary Email",
    icon: siGmail,
    link: "https://mail.google.com/mail/u/0/",
  },
  {
    name: "Discord",
    description: "Primary Chat",
    icon: siDiscord,
    link: "https://discord.com/download",
  },
  {
    name: "Git",
    description: "Version Control",
    icon: siGit,
    link: "https://git-scm.com/downloads",
  },
  {
    name: "CMake",
    description: "Build System",
    icon: siCmake,
    link: "https://cmake.org/download/",
  },
  {
    name: "LLVM",
    description: "Compiler",
    icon: siLlvm,
    link: "https://llvm.org/docs/GettingStarted.html",
  },
  {
    name: "Oh-my-zsh",
    description: "Terminal Theme",
    icon: siZsh,
    link: "https://ohmyz.sh/",
  },
  {
    name: "Docker",
    description: "Containerization",
    icon: siDocker,
    link: "https://docs.docker.com/get-docker/",
  },
  {
    name: "Node.js",
    description: "JavaScript Runtime",
    icon: siNodedotjs,
    link: "https://nodejs.org/en/download/",
  },
  {
    name: "Bun",
    description: "Package Manager",
    icon: siBun,
    link: "https://bun.sh/docs/installation",
  },
  {
    name: "Biome",
    description: "Code Formatter",
    icon: siBiome,
    link: "https://biomejs.dev/getting-started/installation/",
  },
  {
    name: "Bitwarden",
    description: "Password Manager to manage all the login",
    icon: siBitwarden,
    link: "https://bitwarden.com/",
  },
  {
    name: "Vercel",
    description: "Hosting for Projects",
    icon: siVercel,
    link: "https://vercel.com/",
  },
  {
    name: "Railway",
    description: "Hosting for Projects",
    icon: siRailway,
    link: "https://railway.com/",
  },
  {
    name: "Figma",
    description: "Primary Design tool",
    icon: siFigma,
    link: "https://www.figma.com/downloads/",
  },
  {
    name: "Canva",
    description: "Secondary Design tool",
    icon: siCanva,
    link: "https://www.canva.com/",
  },
  {
    name: "Spotify",
    description: "To Listen Music",
    icon: siSpotify,
    link: "https://www.spotify.com/us/download/windows/",
  },
  {
    name: "Postman",
    description: "API Testing",
    icon: siPostman,
    link: "https://postman.com",
  },
  {
    name: "Obsidian",
    description: "For Personal Knowledge Management",
    icon: siObsidian,
    link: "https://obsidian.md",
  },
  {
    name: "Jira",
    description: "For Project Management",
    icon: siJira,
    link: "https://www.atlassian.com/software/jira",
  },
];
